<template>
  <div class="register-content">
    <div class="header">
      <van-icon class="back-icon" name="arrow-left" size="26px" />
      <span class="header-title">注册</span>
    </div>
    <div class="register-body">
      <van-cell-group style="width: 100%;">
        <van-field class="register-input" v-model="userName" placeholder="用户名" size="large" />
        <van-field class="register-input" v-model="phone" placeholder="手机号" size="large" />
        <van-field class="register-input" v-model="activateCode" placeholder="验证码" size="large">
          <van-button slot="button" size="small" type="primary">发送验证码</van-button>
        </van-field>
        <van-field class="register-input" v-model="password" placeholder="密码" size="large" />
        <van-field class="register-input" v-model="repassword" placeholder="再次确认密码" size="large" />
      </van-cell-group>
      <van-button class="submit-btn" slot="button" size="large">注册</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        userName: '',
        phone: '',
        password: '',
        activateCode: '',
      },
      repassword: '', //确认密码
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.register-content {
  width: 100%;
  height: 100vh;
  background: url('../../assets/login/bg1.png') center/cover;
  .header {
    display: flex;
    position: relative;
    justify-content: center;
    margin-bottom: 20px;
    padding: 10px;
    text-align: center;
    vertical-align: middle;
    .back-icon {
      position: absolute;
      left: 5px;
    }
    .header-title {
      font-size: 20px;
    }
  }
  .register-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 90vw;
    height: 80vh;
    margin: auto;
    padding-top: 10px;
    background: #ffffff;
    box-shadow: 0 0 8px 0 rgba(10, 138, 160, 0.1);
    border-radius: 8px;
    .register-input {
      color: #ddd;
    }
    .submit-btn {
      width: 80vw;
      margin-bottom: 30px;
    }
  }
}
</style>
